/**
 * 
 *
 * @author Zébina Samuel <samuel.zebina@education.gouv.fr>
 * @version 1.1
 */
(function (factory) {
    if(typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define('dgrhAutocomplete', ['jQuery', 'jQueryUi'], factory);
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function($) {
    $.widget( "dgrh.autocomplete", $.ui.autocomplete, {
        options: {
            sUrl:                   '#',
            selectCallback:         function(oEvent, oUi) {
                if(typeof oUi.item.item.sNoResult === "string") {
                    $(this).val('');
                    return false;
                }
                $(this).val(oUi.item.label);
                return false;
            },
            extraUrlParamsCallback: function(oOptions){return oOptions;},
            itemFormatterCallback:  function(oItem, sTerm){return '';},
            initCallback:           function() {},
            resizeMenuToElement:    false
        },

        _destroy: function () {
            this._super( "_destroy");
        },

        _create: function () {
            var self    = this,
                options = this.options;
            this._super( "_create");
            this.option({
                source: self._source, 
                select: options.selectCallback,
                focus:  self.focus,
                open:   self.open
            });
        },

        _init: function () {
            var self    = this,
                options = this.options;
            this._super( "_init");
            options.initCallback();
        },

        _source: function(oRequest, response) {
            var self    = this,
                options = this.options;

            $.ajax({
                url:options.sUrl,
                dataType:   'html',
                async:      true,
                minLength:  0,
                data:       options.extraUrlParamsCallback({q: oRequest.term, limit: 20}),
                beforeSend: function(oXhr, oSettings) {
                    oXhr.setRequestHeader("X-DGRH-RqType", 'DgrhAutoComplete');
                    oXhr.overrideMimeType("text/plain");
                },
            }).always(function(sDatas, sStatus, oXhr) {

                $('.ui-autocomplete-input').removeClass('ui-autocomplete-loading');

                //-- BEGIN EN TEST
                //Si session expiré alors redirect to login page
                var sUrl = oXhr.getResponseHeader('X-DGRH-Rurl');
                if(null !== sUrl && 0 < sUrl.length) {
                    setTimeout(function() {
                        //console.log('Redirection');
                        document.location.href = sUrl;
                    }, 300);
                    return;
                }
                //-- END EN TEST

                if('success' == sStatus) {
                    var result = $.map($.trim(oXhr.responseText).split("\n"), function(row) {
                        var aSplit = row.split('|'),
                            oItem  = $.parseJSON(aSplit[1]);
                        return {
                            item:  oItem,
                            label: aSplit[0],
                            value: options.itemFormatterCallback(oItem, oRequest.term)
                        };
                    });
                    response(result);
                }
            });
        },

        _renderItem: function(ul, item) {
            var sValue = '';

            if('' !== item.value) {
                sValue = item.value;
            }

            return $('<li></li>')
                .data('item.autocomplete', item)
                .append('<div class="auto_item">' +  sValue + '</div>')
                .appendTo(ul);
        },

        select: function(oEvent, oUi) {
            $(this).val(oUi.item.label);
            return false;
        },

        focus: function(oEvent, oUi) {
            return false;
        },
        _resizeMenu: function() {
            var self    = this,
                idInput = this.element.attr('id'),
                ul      = this.menu.element,
                options = this.options;

            if(options.resizeMenuToElement) {
                ul.outerWidth(this.element.outerWidth());
            } else {
                this._super( "_resizeMenu");
            }
        },
        open: function(oEvent, oUi) {
            var oAutoComplete = $('.ui-autocomplete');

            $('li.ui-menu-item',        oAutoComplete).addClass('ac_row');
            $('li.ui-menu-item:odd div',  oAutoComplete).addClass('ac_odd');
            $('li.ui-menu-item:even div', oAutoComplete).addClass('ac_even');
        }
    });
}));
